import axios from 'axios';
import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Paginate from '../components/Paginate';
import { Table, Button, Row, Col } from 'react-bootstrap';
import { PRODUCT_CREATE_RESET } from '../constants/productConst'
import { REGISTER_EVENT_LIST_SUCCESS } from '../constants/resgistertEventConst'
import { Link } from 'react-router-dom';
import { Image } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { updateuserevent } from '../actions/usereventActions';
import { listProducts, deleteProduct, createProduct, updateProduct } from '../actions/productActions';
import { useHistory } from 'react-router-dom';
import { useEventContext } from './EventContext';
import { Card, CardImg } from 'react-bootstrap';
import HomeScreen from './HomeScreen';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ShareGiftRegistry = (props, { location, history }) => {

    //console.log("0000000000000000000000000000000000000000");
    //console.log(props.giftregid);
    //console.log("1111111111111111111111111111111111111111");
    //return false;
    const productList = useSelector((state) => state.productList);
    // const { loading, error, products,pages,page } = productList;
    const productDelete = useSelector((state) => state.productDelete);
    const { loading: loadingDel, error: errorDel, success: successDel } = productDelete;
    const productCreate = useSelector((state) => state.productCreate);
    const { loading: loadingCreate, error: errorCreate, success: successCreate, product: createdProduct } = productCreate;
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;
    const [registerevent, setRegisterevent] = useState([]);
    const [userevents, setUserevents] = useState([]);
    const dispatch = useDispatch();
    const createdDate = new Date().toISOString();
    const [products, setProducts] = useState([]);
    const eventId = props.giftregid;
    const [checked, setChecked] = useState(false);
    const { setEventId } = useEventContext();

    const [checkedItems, setCheckedItems] = useState([]);
    const [responseMessage, setResponseMessage] = useState('');
    const [checkoutStatus, setCheckoutStatus] = useState(false);
    const [registryDetails, setRegistryDetails] = useState([]);
    const [purchaseIds, setPurchaseIds] = useState('');
    const [remarkPurchaseIds, setRemarkPurchaseIds] = useState('');


    const [userinfo, setUserInfo] = useState({
        languages: [],
        chkrespo: [],
    });

    const handleChange = (e) => {
        // Destructuring 
        const { value, checked } = e.target;
        const { languages } = userinfo;

        //console.log(`${value} is ${checked}`); 

        // Case 1 : The user checks the box 
        if (checked) {
            setUserInfo({
                languages: [...languages, value],
                chkrespo: [...languages, value],
            });
        }

        // Case 2  : The user unchecks the box 
        // else { 
        //   setUserInfo({ 
        //     languages: languages.filter((e) => e !== value), 
        //     chkrespo: languages.filter((e) => e !== value), 
        //   }); 
        // } 

    };


    useEffect(() => {
        // dispatch(listProducts())    
        //Shopline.handle -> 4wsxmz
        axios.get(`https://wiser-ai.expertvillagemedia.com/api/getgiftproducts/${window.Shopline.handle}/${eventId}`)
        .then((res) => {
            //const {userevents, page, pages} = res.data
            setUserevents(res.data.data)
            // debugger
            const createdDate = new Date().toISOString();
        });
        axios.get(`https://wiser-ai.expertvillagemedia.com/api/getgiftregdata/${eventId}`)
        .then((res) => {
            setRegisterevent(res.data.data);            
        });
    }, []);


    /** DELETE CUSTOMER HANDLE */
    const deleteHandler = async (id) => {
        //if (window.confirm('Are you sure?')) {
            const AppEndPointURL = `https://wiser-ai.expertvillagemedia.com/api/deleteproduct/${id}`;
            try {
                await axios.get(AppEndPointURL);
                axios
                .get(
                    `https://wiser-ai.expertvillagemedia.com/api/getgiftproducts/${window.Shopline.handle}/${eventId}`
                )
                .then((res) => {
                    setUserevents(res.data.data);                
                });
                axios.get(`https://wiser-ai.expertvillagemedia.com/api/getgiftregdata/${eventId}`)
                .then((res) => {
                    setRegisterevent(res.data.data);            
                });
                toast("Item deleted successfully.!");          
            } catch (error) {
                console.error("Error deleting product:", error);
            }
            window.location.href = `https://${window.Shopline.handle}.myshopline.com/pages/evmnew/?evm_shared_giftregistry=${eventId}`;
        //}
    };   

    const updateProductHandler = useCallback((id) => {
        return async (e) => {
            e.preventDefault();
            /** UPDATE API CALL */
            const AppEndPointURL = `https://wiser-ai.expertvillagemedia.com/api/updategiftproductqty`;
            const commonResponse = fetch(AppEndPointURL, {
                method: "POST",
                headers:
                {
                    "Content-Type": "application/json",
                    "Access-Control-Allow-Origin": "*",
                    "Allow": "OPTIONS, GET, HEAD, POST",
                },
                body: JSON.stringify({
                    pro_id: `${id}`,
                    registry_id: `${eventId}`,
                    quantity: e.target.value
                }),
            })
            .then((response) => response.json());

            axios.get(`https://wiser-ai.expertvillagemedia.com/api/getgiftproducts/${window.Shopline.handle}/${eventId}`)
            .then((res) => {
                setUserevents(res.data.data);
            });
            axios.get(`https://wiser-ai.expertvillagemedia.com/api/getgiftregdata/${eventId}`)
            .then((res) => {
                setRegisterevent(res.data.data);            
            });
            //{userevents.map((product, index) => (
            //dispatch(updateuserevent(id, e.target.value)) 
            //))}
        }
    }, []);

    const handleAddProductsClick = () => {
        setEventId(eventId);
        localStorage.setItem('gift_registry_id', eventId);
    };

    // const gotocheckoutpage = (e) => {
    //     e.preventDefault();
    //     /** UPDATE API CALL */    
    //     const AppEndPointURL = `https://wiser-ai.expertvillagemedia.com/api/updateProductBuyStatus`;
    //     const commonResponse = fetch(AppEndPointURL, {
    //       method: "POST",
    //       headers: {
    //         "Content-Type": "application/json",
    //         "Access-Control-Allow-Origin": "*",
    //         Allow: "OPTIONS, GET, HEAD, POST",
    //       },
    //       body: JSON.stringify({
    //         product_ids: `${userinfo.chkrespo}`,
    //         registry_id: `${eventId}`
    //       }),
    //     }).then((response) => response.json());
    //     setTimeout(redirectCheckout, 1000);
    // };


    const gotocheckoutpage = (e) => {
        e.preventDefault();    
        /** UPDATE API CALL */
        console.log("1111------------------------purchaseIds-------------------------11111");
        console.log(purchaseIds);
        
        const AppEndPointURL = `https://wiser-ai.expertvillagemedia.com/api/updateProductBuyStatus`;
        const commonResponse = fetch(AppEndPointURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            Allow: "OPTIONS, GET, HEAD, POST",
          },
          body: JSON.stringify({
            product_ids: `${userinfo.chkrespo}`,
            registry_id: `${eventId}`
            // customer_id: `${window.Shopline.customer.id}`
          }),
        }).then((response) => response.json());
        
    
    
        /** GET ALL GIFT REGISTRY INFORMATION BY ID */
        axios
        .get(
          `https://wiser-ai.expertvillagemedia.com/api/getgiftregdata/${eventId}`
        )
        .then((res) => {
          setRegistryDetails(res.data.data);
          /** SET LOCAL STORAGE  */
          localStorage.setItem("EMCheckoutValues", remarkPurchaseIds);
          //console.log(`https://${window.Shopline.handle}.myshopline.com/cart/${purchaseIds}?checkout[email]=${res.data.data.r_email}&checkout[shipping_address][country]=${encodeURI(res.data.data.r_country)}&checkout[shipping_address][province]=${encodeURI(res.data.data.r_state)}&checkout[shipping_address][first_name]=${encodeURI(res.data.data.r_fname)}&checkout[shipping_address][last_name]=${encodeURI(res.data.data.r_lname)}&checkout[shipping_address][phone]=${res.data.data.r_phone}&checkout[shipping_address][address1]=${encodeURI(res.data.data.r_address)}&tags=EmGiftRegistry&checkout[shipping_address][city]=${encodeURI(res.data.data.r_city)}&checkout[shipping_address][province]=${encodeURI(res.data.data.r_state)}&checkout[shipping_address][zip]=${res.data.data.r_zip}&note=EvmGiftRegistry-${eventId}-${remarkPurchaseIds}&order_note=evm`);
          //return false;
          window.location.href = `https://${window.Shopline.handle}.myshopline.com/cart/${purchaseIds}?checkout[email]=${res.data.data.r_email}&checkout[shipping_address][country]=${encodeURI(res.data.data.r_country)}&checkout[shipping_address][city]=${encodeURI(res.data.data.r_city)}&checkout[shipping_address][province]=${encodeURI(res.data.data.r_state)}&checkout[shipping_address][first_name]=${encodeURI(res.data.data.r_fname)}&checkout[shipping_address][last_name]=${encodeURI(res.data.data.r_lname)}&checkout[phone]=${res.data.data.r_phone}&checkout[shipping_address][mobile]=${res.data.data.r_phone}&checkout[shipping_address][address1]=${encodeURI(res.data.data.r_address)}&checkout[shipping_address][province]=${encodeURI(res.data.data.r_state)}&checkout[shipping_address][city]=${encodeURI(res.data.data.r_city)}&checkout[shipping_address][zip]=${res.data.data.r_zip}&note=EvmGiftRegistry-${eventId}-${remarkPurchaseIds}&order_note=evm`;
          return false;
        });
    
        //return false;
    
        // const AppOrderURL = `https://wiser-ai.expertvillagemedia.com/api/postOrderOnShopline`;
        // const comOrdRes = fetch(AppOrderURL, {
        //   method: "POST",
        //   headers: {
        //     "Content-Type": "application/json",
        //     "Access-Control-Allow-Origin": "*",
        //     Allow: "OPTIONS, GET, HEAD, POST",
        //   },
        //   body: JSON.stringify({
        //     product_ids: `${userinfo.chkrespo}`,
        //     registry_id: `${eventId}`,
        //     customer_id: `${window.Shopline.customer.id}`
        //   }),
        // }).then((response) => response.json());
        
    
    
        // const comOrdRes = fetch('https://wiser-ai.expertvillagemedia.com/api/postOrderOnShopline', {
        //   method: 'POST',
        //     headers: { 'Content-Type': 'application/json' },
        //     body: {
        //     id: 0,
        //     },
        //   })
        //   .then((response) => response.json())
        //   .then((responseJson) => {
        //     console.log("11111111111111111111responseJson111111111111111111111111");
        //     console.log(responseJson);
        //   })
        //   .catch((error) => {
        //     console.error(error);
        //   });
    
    
        // console.log("comOrdRes");
        // console.log(comOrdRes);
        // return false;
        //setTimeout(redirectCheckout, 1000);
      };

    function redirectCheckout(){
        window.location.href = `https://${window.Shopline.handle}.myshopline.com/checkout?checkout[shipping_address][first_name]=Sanjeev&checkout[shipping_address][lastName]=Vishwakarma&checkout[shipping_address][address1]=123, Villa Bhavan&checkout[shipping_address][address2]=&checkout[shipping_address][city]=Washington&checkout[shipping_address][zip]=84780&checkout[shipping_address][country]=United%20States&checkout[shipping_address][province]=Utah&checkout[shipping_address][phone]=1234567891`;
        return false;
    }
    const formatDate = (datestr) => {
        var options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(datestr).toDateString([], options);
      };
    const evm_giftreg_addcart = (e) => {
        e.preventDefault();
        let itemArray = [];
        if (userinfo.chkrespo.length > 0) {
            /* ADD TO CART */
            let proArray = [];
            let remarkProArray = [];
            userinfo.chkrespo.map((item) => {
                let idata = item.split('_');
                let pid = idata[0];
                let qty = idata[1];
                // proArray.push({
                //     quantity: qty,
                //     id: `${pid}`,
                // });
                let rid = idata[2];
                proArray.push(pid+':'+qty);        
                remarkProArray.push(rid+':'+qty);
            });
            // const repos = axios.post('/cart/add.js', { "items": proArray })
            //     .then(response => console.log("Add Product Response", response.data))
            //     .catch(error => {
            //     });

            console.log("-----------------------------------------proArray------------------------------------------");
            console.log(proArray.toString());

            setPurchaseIds(proArray.toString());
            setRemarkPurchaseIds(remarkProArray.toString());

            toast("Giftregistry items added in cart successfully.!");
            setCheckoutStatus(true);
        } else {
            toast("Please select one of the items first.");
        }
    };

    return (
        <div className="evm_gift-manage-regi_modal">
            <div className='evm_giftregistry_cancel'>
                <Link to="/pages/evmnew">
                    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
                        <path d="M19 19L23.4793 23.4793M19 19L14.5223 23.4793M19 19L23.4793 14.5223M19 19L14.5223 14.5223" stroke="#8780A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        <path d="M19 34.8333C27.7448 34.8333 34.8333 27.7447 34.8333 19C34.8333 10.2552 27.7448 3.16663 19 3.16663C10.2553 3.16663 3.16667 10.2552 3.16667 19C3.16667 27.7447 10.2553 34.8333 19 34.8333Z" stroke="#8780A0" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                </Link>
            </div>
            
            <div className='evm_giftregistry_product'>
                <form id="aaa-registry-products-form">
                    <div className="table-responsive sm_border_none">
                        <div className='tbl-padding'>&nbsp;</div>
                        <div className='tbl-padding'>
                            <h4>Gift Registry Notes:{registerevent.regaddinfo}</h4>
                            <h4>Public Message To Friends And Family:{registerevent.regmessage}</h4>
                        </div>
                        <div className='tbl-padding'>&nbsp;</div>
                        <table className="table table-bordered searchlist_responsive table_custom">
                            <thead className="sm_d_none">
                                <tr>
                                    <th style={{ width: 'auto' }}>Event Name</th>
                                    <th style={{ width: 'auto' }}>Record Owner</th>
                                    <th style={{ width: 'auto' }}>Create Date</th>
                                    <th style={{ width: 'auto' }} className="">Event Date</th>
                                    <th style={{ width: 'auto' }} className="">Additional Information</th>
                                </tr>
                            </thead>
                            <tbody>              
                                <td>{registerevent.regtype}</td>
                                <td>{registerevent.r_fname}</td>
                                <td>{formatDate(registerevent.created_at)}</td>
                                <td>{formatDate(registerevent.regdate)}</td>
                                <td>{registerevent.regaddinfo}</td>
                            </tbody>
                        </table>
                        <div className='tbl-padding'>&nbsp;</div>
                        <table className="table table-bordered table_custom registry_products_table_responsive">
                            <thead>
                                <tr>
                                    <th>Yes/No</th>
                                    <th>Purchased By</th>
                                    <th>Product Name</th>
                                    <th>Product Price</th>
                                    <th>Product Image</th>
                                    <th>Quantity</th>
                                    <th>Update Quantity</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {userevents.map((product, index) => (
                                    <tr key={index} style={{ backgroundColor: product.status === 1 || product.status === 0 ? 'white':'#efefef' }}>
                                        {product.status === 1 || product.status === 0 ? 
                                            (
                                                <td><input type="checkbox" style={{ "-webkit-appearance": "textfield" }} name={product.name} value={`${product.variant_id}_${product.quantity}_${product.id}`} onChange={handleChange} /></td>
                                            ) :
                                            (
                                                <td>Purchased</td>
                                            )
                                        }
                                        <td>
                                        {product.purchase_customer_email || product.purchase_customer_name !== null ? 
                                            (
                                                <table className="evm-order-details-cls">
                                                    <tr><td>Name:</td><td>{product.purchase_customer_name}</td></tr>
                                                    <tr><td>Qty:</td><td>{product.quantity}</td></tr>
                                                    <tr><td>Date:</td><td>{product.purchase_date}</td></tr>
                                                </table>
                                            )                         
                                            : ('-')
                                        }
                                        </td>
                                        <td>{product.name}</td>
                                        <td>{product.store_currency}{''}{product.price.toFixed(2)}</td>
                                        <td><Image alt={product.name} src={product.image} style={{ width: "90px",height: "90px" }} /></td>
                                        <td>{product.quantity}</td>
                                        {/* <td><input type='number' id={`evm_qty_${product.product_id}`} style={{ width: "80px", height: "40px" }} defaultValue={product.quantity} onChange={updateProductHandler(product.id)} min={0} max={product.available_quantity} /></td> */}                                        
                                        {product.status === 1 || product.status === 0 ?
                                        (<>
                                        <td>
                                            <input
                                            type="number"
                                            id={`evm_qty_${product.product_id}`}
                                            style={{ width: "80px", height: "40px" }}
                                            defaultValue={product.quantity}
                                            onChange={updateProductHandler(product.id)}
                                            min={1}
                                            max={product.available_quantity}
                                            />
                                        </td>
                                        <td>
                                            <Link
                                            to="#"
                                            className="btn-sm"
                                            onClick={() => deleteHandler(product.id)}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    width="38"
                                                    height="38"
                                                    viewBox="0 0 38 38"
                                                    fill="none"
                                                >                          
                                                    <path
                                                        d="M30.0833 17.4166V32.3C30.0833 32.5519 29.9832 32.7936 29.8051 32.9717C29.6269 33.1499 29.3853 33.25 29.1333 33.25H8.86666C8.61471 33.25 8.37307 33.1499 8.19491 32.9717C8.01675 32.7936 7.91666 32.5519 7.91666 32.3V17.4166"
                                                        stroke="#8780A0"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M15.8333 26.9166V17.4166"
                                                        stroke="#8780A0"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M22.1667 26.9166V17.4166"
                                                        stroke="#8780A0"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                    <path
                                                        d="M12.6667 11.0833H25.3333M12.6667 11.0833H4.75M12.6667 11.0833V5.7C12.6667 5.44804 12.7668 5.20641 12.9449 5.02825C13.1231 4.85009 13.3647 4.75 13.6167 4.75H24.3833C24.6353 4.75 24.8769 4.85009 25.0551 5.02825C25.2332 5.20641 25.3333 5.44804 25.3333 5.7V11.0833M25.3333 11.0833H33.25"
                                                        stroke="#8780A0"
                                                        stroke-width="2"
                                                        stroke-linecap="round"
                                                        stroke-linejoin="round"
                                                    />
                                                </svg>
                                            </Link>
                                        </td>
                                        </>
                                        ) : (
                                        <>
                                        <td>&nbsp;</td>
                                        <td>&nbsp;</td>
                                        </>
                                        )}
                                    </tr>
                                ))}
                                {userevents.length === 0 &&
                                    <tr><td colSpan="7">Product not found.</td></tr>
                                }                                
                            </tbody>
                        </table>
                    </div>
                    <div className="full-width update_cart_bottom_fix" style={{ borderRadius: '0 !important', textAlign: 'center' }}>
                        <div className="btn_wrapper evm_addtocart_btn">
                            {userevents.length > 0 && checkoutStatus !== true && (
                            <button className="btn btn-primary addtocart evm_giftreg_addcart evm_btn" onClick={evm_giftreg_addcart} >
                                Add To Cart
                            </button>
                            )}
                            {checkoutStatus === true &&
                                <button className="btn btn-primary evm_btn" onClick={gotocheckoutpage} >
                                Check Out
                                </button>
                            }
                            <ToastContainer
                                position="bottom-right"
                                autoClose={5000}
                                hideProgressBar={false}
                                newestOnTop={false}
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                                theme="colored"
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default ShareGiftRegistry;